import styles from "./RangeSliderWithInput.module.scss";
import classnames from "classnames/bind";
import RangeSlider from "../Slider";
import TextBox from "../TextBox";

let cx = classnames.bind(styles);

const RangeSliderWithInput = (props) => {
  const {
    label,
    name,
    value,
    handleChange,
    min,
    max,
    type,
    unit,
    className,
    minLength,
    maxLength,
  } = props;

  return (
    <div className={cx(styles.Container, className)}>
      <div className={styles.LabelInputUnit}>
        <span className={styles.Label}>{label}</span>
        <div className={styles.TextBox}>
          <TextBox
            className={styles.InputText}
            value={value}
            id={name}
            name={name}
            handleChange={handleChange}
            type={type}
            minLength={minLength}
            maxLength={maxLength}
            min={min}
            max={max}
          />
          <div className={styles.Unit}>{unit}</div>
        </div>
      </div>
      <RangeSlider
        name={name}
        sliderValue={value}
        handleChange={handleChange}
        min={min}
        max={max}
      />
    </div>
  );
};

export default RangeSliderWithInput;
